import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Post, Query, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { AllPostTypesResponseModel } from './dto/all-post-types-response.model';
import { PostTypeResponseModel } from './dto/post-type-response.model';
import { PostTypeDTO } from './dto/post-type.dto';
import { PostTypeStatusDTO } from './dto/post-type.request';
import { PostTypeService } from './post-type.service';

@ApiTags('PostType')
@Controller('post-type')
export class PostTypeController {
    constructor (
        private postTypeService: PostTypeService
    ) {}

    /**
     * create a post type 
     * @param queryParams  which returns app version
     * @param postTypeDto  which passes the details to be saved
     * @param request 
     * @returns postTypeResponse which returns the newly saved data along with status (true/false), errortype, intlcode, internal message which provides message the calling function.   
     */
    @Post('/createPostType')
    async createPostType(@Query() queryParams, @Body() postTypeDto: PostTypeDTO, @Req() request: Request): Promise<PostTypeResponseModel> {
        try {
            return await this.postTypeService.createPostType(queryParams, postTypeDto, request);
        } catch (error) {
            return errorHandler(PostTypeResponseModel, error);
        }
    }

    /**
     * update a post type
     * @param queryParams which returns app version
     * @param postTypeDto which passes the details to be updated
     * @param request 
     * @returns postTypeResponse which returns the updated data along with status (true/false), errortype, intlcode, internal message which provides message the calling function.   
     */

    @Post('/updatePostType')
    async updatePostType(@Query() queryParams, @Body() postTypeDto: PostTypeDTO, @Req() request: Request): Promise<PostTypeResponseModel> {
        try {
            return await this.postTypeService.updatePostType(queryParams, postTypeDto, request);
        } catch (error) {
            return errorHandler(PostTypeResponseModel, error);
        }
    }

    /**
     * get all active post types 
     * @param queryParams which return api veresion 
     */
    @Get('/getActivePostTypes')
    async getActivePostTypes(@Query() queryParams): Promise<AllPostTypesResponseModel> {
        try {
            return await this.postTypeService.getActivePostTypes(queryParams);
        } catch (error) {
            return errorHandler(AllPostTypesResponseModel, error);
        }
    }

    @Post('/updatePostTypeStatus')
    async updatePostTypeStatus(@Query() queryParams, @Body() postTypeStatusDto: PostTypeStatusDTO, @Req() request: Request): Promise<PostTypeResponseModel> {
        try {
            return await this.postTypeService.updatePostTypeStatus(queryParams, postTypeStatusDto, request);
        } catch (error) {
            return errorHandler(PostTypeResponseModel, error);
        }
    }
    
}


